import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["min", "max"];

  applyPreset(event) {
    event.preventDefault();
    this.minTarget.value = event.params.min;
    this.maxTarget.value = event.params.max;
  }

}
